export class LocalStorageTeenus {
    public salvesta(key: string, value: string): boolean {
        try {
            localStorage.setItem(key, value)
            return true
        }
        catch {
            return false
        }
    }

    public kustuta(key: string): boolean {
        try {
            localStorage.removeItem(key);
            return true
        }
        catch {
            return false
        }
    }

    public anna(key: string): string | null {
        return localStorage.getItem(key);
    }
}